import { TINUITI_TEST_HOME_SERVICES } from '@src/Pages/MMM/mmm-utils';

export const CDN = 'https://cdn.blisspointmedia.com';

// CDN file names for each company's logos: the Image Uploader writes them and ClientLogo reads them.
export const CompanyLogoFile = {
  LOGO: 'logo.png',
  LOGO_DARK: 'logo_dark.png',
  SQUARE_LOGO: 'square_logo.png',
  SQUARE_LOGO_DARK: 'square_logo_dark.png'
} as const;

// Demo/test companies all share the tinuitidemo logos.
export const normalizeLogoCid = (cid: string): string =>
  cid.includes('tinuitidemo') || cid === 'tinuititest' || cid === TINUITI_TEST_HOME_SERVICES
    ? 'tinuitidemo'
    : cid;
